import React from 'react';
import { connect } from 'react-redux';
import { logoutUser } from '../actions';
import { getProductConfig } from '../backend/productConfig';
import history from '../history';
import '../App.css';
import './liveStyle.css';

/**
 * ControlBoxView - Action buttons sidebar section
 *
 * Shows: Playback, Setup (admin only), Full Viewer (desktop only), Logout
 */
const ControlBoxView = props => {
    // Playback = the multi-cam view (/mcplayback), labeled "Playback", shown per the fPlayback
    // USER RIGHT (same across all products; legacy single-cam playback retired). Cloud also has
    // no Java desktop viewer to link to (hasViewerDownloads:false).
    const { hasViewerDownloads } = getProductConfig();

    // hidePlayback (desktop account menu, #86bb5dx62): the redesigned desktop header owns
    // the Live/Playback toggle, so the account dropdown drops the redundant playback buttons
    // and shows just Setup / Full Viewer / Logout. Default false → the component is unchanged
    // everywhere else it's reused.
    const showPlayback = !props.hidePlayback;

    return (
        <div className="live-btn-container">
            { showPlayback && props.fPlayback === 1 ?
                <button
                    className="live-btn live-btn--spaced"
                    onClick={() => history.push('/mcplayback')}>
                    Playback
                </button> :
                null
            }

            {/* hideSetup (desktop account menu, #86bb5dx62): the desktop header already has a Setup
                button next to the avatar, so the account dropdown drops the duplicate. Setup is ALWAYS
                shown otherwise (David 2026-08-05) and routes to the shared /setup shell — the shell
                itself is ungated; individual modules gate per-right (Display for everyone, config for
                admins). */}
            { !props.hideSetup &&
                <button
                    className="live-btn live-btn--spaced"
                    onClick={() => history.push('/setup')}>
                    Setup
                </button>
            }

            { hasViewerDownloads && props.platform !== 'Ios' && props.platform !== 'Android' ?
                <a href={ props.fEview ?
                           (props.platform === 'Win' ? "/elauncher.php" : "/eview.php") :
                           (props.platform === 'Win' ? "/launcher.php" : "/dview.php")
                         }
                  className="live-btn live-btn--spaced">
                  {props.fEview ? "E Viewer" : "Full Viewer"}
                </a> :
                null
            }
            <button
                className="live-btn live-btn--spaced-sm live-btn--danger"
                onClick={ () => { props.logoutUser(props.sSess); history.push("/") } }>
                Logout
            </button>
        </div>
    )
}

const mapStateToProps = state => {
    const { sSess } = state.auth;
    const { platform } = state.utility;
    const { sServer, fEview } = state.server;
    const { conf } = state.config;
    const { camBrowserCam } = state.camera;
    const { fAdmin, fPlayback} = state.user;
    return {
        sSess,
        platform,
        sServer,
        fEview,
        conf,
        camBrowserCam,
        fAdmin,
        fPlayback
    };
}

export default connect(mapStateToProps, { logoutUser })(ControlBoxView);
